import React from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import useStore from '../../services/hooks/useStore';
import NotificacaoService from '../../services/NotificacaoService';
import styled from 'styled-components';

const NotificationBarContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 24px;
  background-color: rgb(255, 152, 0);
  border-bottom: 1px solid #e0e0e0;
  width: 100%;
`;

const NotificationContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  margin-right: 16px;
`;

const NotificationMessage = styled.span`
  font-size: 18px;
  color: #ffffff;
`;

const ActionButton = styled.button`
  background-color: rgb(255, 152, 0);
  color: white;
  border: 1px solid #ffffff;
  padding: 2px 16px;
  border-radius: 10px;
  cursor: pointer;
  margin-top: 10px;
  font-size: 14px;
  
  &:hover {
    opacity: 0.9;
  }
`;

const CloseButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  .MuiIconButton-root {
    color: white;
  }
`;

const NotificationBar: React.FC = () => {
  const store = useStore();
  const history = useHistory();

  const getLatestUnreadNotification = () => {
    return store.notificacoes
      .filter(n => !n.lido)
      .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())[0];
  };

  const handleClose = async (notificationId: number) => {
    try {
      await NotificacaoService.marcarComoLida(notificationId, store?.propriedade?.id || 0);
      const notificacoes = await NotificacaoService.buscarNotificacoes(store?.propriedade?.id || 0);
      store.setNotificacoes(notificacoes);
      store.setNotificacoesNaoLidas(notificacoes.filter(n => !n.lido).length);
    } catch (error) {
      console.error('Erro ao marcar notificação como lida:', error);
    }
  };

  const handleAction = (tipo: string) => {
    switch (tipo) {
      case 'despesa':
        history.push('/financeiro/movimentacao');
        break;
      case 'racao':
        history.push('/producao/estoque');
        break;
      case 'parcela':
        history.push('/financeiro/movimentacao');
        break;
      default:
        break;
    }
  };

  const latestNotification = getLatestUnreadNotification();

  if (!latestNotification) {
    return null;
  }

  return (
    <NotificationBarContainer>
      <NotificationContent>
        <NotificationMessage>
          {latestNotification.mensagem}
        </NotificationMessage>
        <ActionButton onClick={() => handleAction(latestNotification.tipo)}>
          {latestNotification.tipo === 'racao' ? 'Ver Estoque' : 'Ver Despesa'}
        </ActionButton>
      </NotificationContent>
      <CloseButtonWrapper>
        <IconButton size="small" onClick={() => handleClose(latestNotification.id)}>
          <CloseIcon style={{ color: '#ffffff' }} />
        </IconButton>
      </CloseButtonWrapper>
    </NotificationBarContainer>
  );
};

export default observer(NotificationBar); 